/*
|--------------------------------------------------------------------------
| Paywall: Press Plus
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.paywall.pressplus = {
	"init": function(){
		if (this.isDisabled()) {return;}
		var commonJS 		= __gh__webApp.common;
			mainIDCheck		= commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"paywall.pressplus.ids.main");
		if(!mainIDCheck){return;}
		var currentPage				= __gh__webApp.currentPage,
			mainID 					= __gh__coreData["3rdPartyData"].paywall.pressplus.ids.main,
			precheckReturnValue		= (currentPage.isArticle()) ? "1" : "false"; //disable metering if not on article page
			
		this.loadLibrary();
		
		// Add variables to head section
		__gh__webApp.common.loadScript({
			"async"			: false,
			"text"			: "var pp = {client: {config:{'zone':'"+mainID+"','mode':'universal','debug':0,'precheck': function(){return "+precheckReturnValue+";}}}};"
		});
		this.bindEvents();
	},

	"loadLibrary": function() {
		if (this.isDisabled()) {return;}
		__gh__webApp.common.loadScript({
			"async": false,
			"src": "http://s.ppjol.net/lightbox/pp4.js"
		});
	},

	"meterArticle": function(articleID){
		var commonJS = __gh__webApp.common;
		if (this.isDisabled() || !commonJS.isObjectPropertySet(pp,"client.meter")) {return;}
		pp.client.meter(articleID);
	},

	"bindEvents":function(){
		$(document).on('click','[data-gh-paywall]',function(){
			$.pressplus.f.pop('login');
		});
	},
	
	"isDisabled": function(){
		return (__gh__coreData["3rdPartyData"].paywall.pressplus.disabled);
	},
	
	"isUserLoggedIn": function(){
		if (this.isDisabled()) {return false;}
		var commonJS = __gh__webApp.common;
		return (commonJS.getCookie("ppUser"));
	},
	"userLogin":function(){
		if (this.isDisabled()) {return;}
			$.pressplus.f.pop('login');
	}
};
